import * as React from 'react';
import { connect, TAdFoxBannerProps } from '@cian/adfox-component';

import { TBannerPlace } from '../../types/adfoxBanner';
import { createTGBanner } from '../TGBanner';

type TProps = {
  place: TBannerPlace;
};

type TAdFoxBannerComponentProps = TAdFoxBannerProps & TProps & { className?: string };

export class AdFoxBanner extends React.Component<TAdFoxBannerComponentProps, {}> {
  public render() {
    const { place, ...sharedProps } = this.props;
    const Component = connect(createTGBanner(place, sharedProps.className) || undefined);

    return <Component {...sharedProps} />;
  }
}
